import { cn } from "@/utils/theme";
import {
  Avatar,
  AvatarFallback,
  Button,
  Icon,
} from "@elaniintc/goes-design-system";

interface InsolvencyBannerProps {
  count?: number | null;
  title?: string;
  description?: string;
  onClick?: () => void;
  variant?: "warning" | "danger";
}

export const InsolvencyBanner = ({
  count,
  title,
  description,
  onClick,
  variant = "warning",
}: InsolvencyBannerProps) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-2 p-3 border rounded-xl",
        variant === "warning" &&
          "border-contextual-warning bg-surface-warning-accent-quiet",
        variant === "danger" &&
          "border-contextual-danger bg-surface-danger-accent-quiet",
      )}
    >
      <div>
        <p
          className={cn(
            "leading-3xl font-semibold flex gap-1.5 items-start",
            variant === "warning" && "contextual-text-warning",
            variant === "danger" && "contextual-text-danger",
          )}
        >
          <Avatar size="2xs">
            <AvatarFallback color={variant}>
              <Icon type="fas" name="sack-dollar" />
            </AvatarFallback>
          </Avatar>
          {title ||
            `Tiene ${count || ""} infracciones que debe
              pagar antes de la resolución de las solicitudes que utilicen este
              expediente`}
        </p>
        <p
          className={cn(
            "text-sm",
            variant === "warning" && "contextual-text-warning",
            variant === "danger" && "contextual-text-danger",
          )}
        >
          {description ||
            "Si no se realiza el pago, las solicitudes utilizadas en este expediente podrían ser denegada."}
        </p>
      </div>
      <Button
        variant={"ghost"}
        size={"xs"}
        className={cn(
          "self-start w-fit",
          variant === "warning" && "text-warning",
          variant === "danger" && "text-danger",
        )}
        onClick={onClick}
      >
        Ver infracciones
        <Icon type="far" name="arrow-up-right" />
      </Button>
    </div>
  );
};
